import React from 'react';
import ReactDOM from 'react-dom';
import Login from './Login';
import './style.css';
// import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <div className='google-signin'>
      <Login></Login>
  </div>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals